import { Badge, Flex, Heading, Text } from '@chakra-ui/react';
import { projectApi } from '@texas/api/endpoints/projectsApi';
import { useApiResource } from '@texas/api/hooks/useApiResource';
import {
  MetadataList,
  MetadataListRow,
} from '@texas/components/shared/MetadataList';
import { NoData } from '@texas/components/shared/NoData';
import { SpinnerWithLabel } from '@texas/components/shared/SpinnerWithLabel';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

interface Props {
  customerId: number;
}

export function ProjectHoverCard({ customerId }: Props) {
  const { t } = useTranslation();
  const { data, refetch, loading } = useApiResource(
    projectApi.getProjectFromBrand,
  );

  useEffect(() => {
    refetch(customerId);
  }, [customerId, refetch]);

  if (loading) {
    return <SpinnerWithLabel label={t('general.loading')} />;
  }

  if (!data) {
    return <NoData label={t('project.noProject')} />;
  }

  return (
    <Flex flexDir="column" gap={2} minW="220px">
      <Flex alignItems="center" gap={2}>
        <Heading fontSize="md">{data.name}</Heading>
        {data.archived && (
          <Badge colorScheme="orange">{t('general.archived')}</Badge>
        )}
      </Flex>
      <MetadataList>
        <MetadataListRow label={t('general.project')}>
          <Text>{data.erpId}</Text>
        </MetadataListRow>
        {data.countryCode && (
          <MetadataListRow label={t('project.country')}>
            <Text>{data.countryCode}</Text>
          </MetadataListRow>
        )}
        {data.keyAccountManager && (
          <MetadataListRow label={t('general.keyAccountManager')}>
            <Text>{data.keyAccountManager.name}</Text>
          </MetadataListRow>
        )}
        {data.archived && (
          <MetadataListRow label={t('general.archivedDate', { date: '' })}>
            <Text>{new Date(data.archived).toLocaleDateString()}</Text>
          </MetadataListRow>
        )}
      </MetadataList>
    </Flex>
  );
}
